module.exports = (partialValue, totalValue) => {
    return Math.trunc((100 * partialValue) / totalValue);
 } 